import { timer, throwError, Observable } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { HttpErrorResponse } from '@node_modules/@angular/common/http';

export interface RetryParams {
    /**
     * Maximum number of attempts
     */
    maxAttempts?: number;
    /**
     * Duration in ms to wait before retrying
     */
    scalingDuration?: number;
    /**
     * Function to determine if a request should be retried
     */
    shouldRetry?: ({ status }: { status: number }) => boolean;
}

/**
 * Default parameters for the retry strategy
 */
const defaultParams: RetryParams = {
    maxAttempts: 3,
    scalingDuration: 1000,
    shouldRetry: ({ status }) => status >= 400,
};

/**
 * Generic retry strategy for http requests
 * @param params
 */
export const genericRetryStrategy =
    (params: RetryParams = {}) =>
    (attempts: Observable<any>) =>
        attempts.pipe(
            mergeMap((error: HttpErrorResponse, i: number) => {
                const { maxAttempts, scalingDuration, shouldRetry } = { ...defaultParams, ...params };
                const retryAttempt = i + 1;
                // if maximum number of retries have been met or response is a status code we don't wish to retry, throw error
                if (retryAttempt > maxAttempts || !shouldRetry(error)) {
                    return throwError(error);
                }
                console.log(`Url: ${error.url}. Attempt ${retryAttempt}: retrying in ${retryAttempt * scalingDuration}ms`);
                // retry after scaling duration...
                return timer(retryAttempt * scalingDuration);
            })
        );
